import { FC } from "react";
import { CalendarIcon } from "src/assets/Icons";
import { MdPerson } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { perpareSeachObjectChipValues } from "src/Modules/Hotels/Components/SearchChip/utils/index";
import { SearchFormInputs } from "src/Modules/Hotels/constants/SearchPage";

const SummarySidebar: FC<{ searchObject: SearchFormInputs }> = ({ searchObject }) => {
  const { t } = useTranslation();
  const { checkinDate, checkoutDate, totalPassengers } = perpareSeachObjectChipValues(searchObject);

  const totalAdults = searchObject?.rooms?.reduce((sum, r) => sum + (r.adults ?? 0), 0) ?? 0;
  const totalChildren = searchObject?.rooms?.reduce((sum, r) => sum + (r.children ?? 0), 0) ?? 0;

  const guestsLabel =
    [
      totalAdults ? (totalAdults === 1 ? t("Hotels.common.oneAdult") : t("Hotels.common.adultsCount", { count: totalAdults })) : null,
      totalChildren ? (totalChildren === 1 ? t("Hotels.common.oneChild") : t("Hotels.common.childrenCount", { count: totalChildren })) : null,
    ]
      .filter(Boolean)
      .join(", ") ||
    (totalPassengers === 1 ? t("Hotels.common.oneGuest") : t("Hotels.common.guestsCount", { count: totalPassengers }));

  return (
    <div className="rounded-lg border border-border-minimal bg-background-default p-6 shadow-[0_12px_32px_0_rgba(25,28,29,0.04)]">
      <h3 className="mb-5 text-lg font-bold text-font-default">{t("Hotels.booking.summary")}</h3>
      <div className="space-y-5">
        {(checkinDate || checkoutDate) && (
          <div className="flex items-start gap-4">
            <div className="text-icon-active shrink-0 rounded-md bg-background-minimal p-2">
              <CalendarIcon />
            </div>
            <div className="flex flex-col">
              <span className="mb-1 text-[10px] font-bold uppercase tracking-wider text-font-subtle">{t("Hotels.booking.selectedDates")}</span>
              <span className="text-sm font-semibold leading-tight text-font-default">
                {checkinDate && checkoutDate ? `${checkinDate} - ${checkoutDate}` : checkinDate || checkoutDate}
              </span>
            </div>
          </div>
        )}
        {totalPassengers > 0 && (
          <div className="flex items-start gap-4">
            <div className="text-icon-active shrink-0 rounded-md bg-background-minimal p-2">
              <MdPerson className="h-5 w-5" />
            </div>
            <div className="flex flex-col">
              <span className="mb-1 text-[10px] font-bold uppercase tracking-wider text-font-subtle">{t("Hotels.booking.guests")}</span>
              <span className="text-sm font-semibold leading-tight text-font-default">{guestsLabel}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SummarySidebar;
